import { Box, styled } from '@mui/material';
import UPButton from 'components/button';

export const BigCostTooltipContainer = styled(Box)({
  height: '25%',
  display: 'flex',
  justifyContent: 'space-between',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  alignItems: 'flex-end',
  padding: '10px 40px',
});

export const InvoicesButtonContainer = styled(Box)(() => ({
  height: '25%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px',
}));

export const SmallCostTooltipContainer = styled(Box)(() => ({
  height: '15%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 40px',
}));

export const ViewInvoicesButton = styled(UPButton)(() => ({ height: '75%' }));

export const StyledCostTooltip = styled(Box)(() => ({
  width: '250px',
  height: '250px',
  backgroundColor: 'white',
  borderRadius: '5px',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  zIndex: '2000',
}));
